import React from 'react';
import {
    Modal,
    Typography,
    Box,
    Icon,
    Button} from '@mui/material'

import './styles.scss';

export function BlockModal({ isVisible, handleClose }) {

    return (
        <div>       
            <Modal
                className="tw-w-screen tw-h-screen tw-z--1 tw-bg-[rgba(100,100,100,0.5)]                "
                open={isVisible}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box className="tw-fixed tw-top-1/2 tw-left-1/2 tw-transform tw--translate-x-1/2 tw--translate-y-1/2 tw-w-[450px] tw-h-[150px] tw-border tw-border-gray-300 tw-rounded-md tw-bg-white tw-px-8 tw-py-5 tw-text-center">
                    <div className='flex justify-end'>
                        <Button onClick={handleClose} className="tw-p-0"><Icon>close</Icon></Button>
                    </div>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        {"Atenção !"}
                    </Typography>
                    <Typography id="modal-modal-description">
                        {"Anunciante bloqueado. Por favor entre em contato com o suporte para regularização."}
                    </Typography>
                </Box>
            </Modal>
        </div>
    );
}